import T from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import {
  fetchRateLogTable,
  removeLogRow,
  clearRateLogTable,
  reloadRateLogTable,
  reloadWidgetRateLogTable,
} from 'reducers/digitalLogbook/reducer'
import ListFromTable from 'components/common/ListFromTable'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import Sort from 'lib/psfs/Sort'
import { reloadCageList } from 'reducers/slaMonitor/reducer'
import withPromise from 'helpers/withPromise'
import { getTime } from 'helpers/timeFrames'
import messages from '../translate'

class LogTable extends ListFromTable {
  static contextTypes = {
    router: T.shape({
      history: T.object.isRequired,
    }).isRequired,
  }

  constructor(props) {
    super(props)
    this.deleteEntity = this.props.removeLogRow
    this.clearReducerState = this.props.clearRateLogTable
  }

  componentDidMount() {
    const { activeSite, activeCage, activeDate } = this.props
    this.getTableData(activeSite, activeCage, activeDate, this.psfs)
  }

  shouldComponentUpdate(nextProps) {
    const { activeSite, activeCage, activeDate } = this.props

    if (
      activeSite !== nextProps.activeSite ||
      activeDate !== nextProps.activeDate ||
      activeCage !== nextProps.activeCage ||
      nextProps.isReloadRateLogTable
    ) {
      this.getTableData(
        nextProps.activeSite,
        nextProps.activeCage,
        nextProps.activeDate,
        this.psfs,
      )

      return false
    }

    return true
  }

  getTableData = (activeSite, activeCage, activeDate, psfs) => {
    this.psfs.createSort('time', Sort.DESC)
    this.props.fetchRateLogTable({
      siteId: activeSite,
      cageId: +activeCage,
      date: activeDate.format('YYYY-MM-DD'),
      psfs,
    })
  }

  getTableProps() {
    return {
      title: 'Logbook History',
      showFilterBar: false,
      sorting: false,
      paging: false,
      searching: false,
      creating: false,
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()
    columns.add(new Column('username', formatMessage(messages.logged)))
    columns.add(
      new Column('time', formatMessage(messages.time), {
        render: rowData => getTime(rowData.hour, rowData.minute),
      }),
    )
    columns.add(
      new Column('rate', formatMessage(messages.value), {
        render: rowData => (rowData.rate === 5 ? 'X' : rowData.rate),
      }),
    )

    return columns
  }

  getConfirmDialogProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.deleteLog),
      message: formatMessage(messages.deleteLogMessage),
    }
  }

  onConfirmActionConfirmDialog = () => {
    const { confirmParams } = this.state

    if (confirmParams) {
      withPromise(this.deleteEntity, confirmParams).then(errors => {
        if (errors) return Promise.resolve(errors)

        this.props.reloadCageList(true)
        this.props.reloadRateLogTable(true)
        this.props.reloadWidgetRateLogTable(true)
      })
    }

    this.onCloseConfirmDialog()
  }

  getActions() {
    const {
      activeSite,
      activeDate,
      intl: { formatMessage },
    } = this.props
    const actions = new ActionCollection()
    actions.add(
      new Action('delete', formatMessage(messages.removeEntry), row => {
        this.onOpenConfirmDialog({
          logId: row.id,
          siteId: activeSite,
          cageId: 0,
          date: +activeDate.format('YYYYMMDD'),
          psfs: this.psfs,
        })
      }),
    )

    return actions
  }
}

export default connect(
  state => ({
    tableData: state.getIn(['digitalLogbook', 'rateLogTable']),
    isReloadRateLogTable: state.getIn([
      'digitalLogbook',
      'isReloadRateLogTable',
    ]),
  }),
  {
    fetchRateLogTable,
    removeLogRow,
    clearRateLogTable,
    reloadCageList,
    reloadWidgetRateLogTable,
    reloadRateLogTable,
  },
)(injectIntl(LogTable))
